import {
  FieldMappingNumberField,
  FieldMappingNumberFieldProps,
} from '@components/field-mapping-number-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormFieldMappingNumberFieldProps<T = unknown> = FormFieldProps<
  FieldMappingNumberFieldProps,
  T
>;

export function FormFieldMappingNumberField<T>(props: FormFieldMappingNumberFieldProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'field-mapping' });

  return <FieldMappingNumberField {...props} {...formFieldProps} />;
}
